var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdcopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 11.5,
    transform: "matrix(-1 0 0 1 12 12)",
    fill: "white",
    stroke: "#1A6996"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.698 17H13.442V15.96C12.8233 16.7387 12.0553 17.128 11.138 17.128C10.2313 17.128 9.46867 16.8667 8.85 16.344C8.23133 15.8107 7.922 15.1067 7.922 14.232C7.922 13.3467 8.242 12.6853 8.882 12.248C9.522 11.8107 10.3967 11.592 11.506 11.592H13.298V11.544C13.298 10.6267 12.8127 10.168 11.842 10.168C11.426 10.168 10.9833 10.2533 10.514 10.424C10.0553 10.584 9.666 10.7867 9.346 11.032L8.274 9.48C9.40467 8.65867 10.6953 8.248 12.146 8.248C13.1913 8.248 14.0447 8.50933 14.706 9.032C15.3673 9.55467 15.698 10.3813 15.698 11.512V17ZM13.282 13.72V13.304H11.778C10.818 13.304 10.338 13.6027 10.338 14.2C10.338 14.5093 10.45 14.7493 10.674 14.92C10.9087 15.08 11.2393 15.16 11.666 15.16C12.0927 15.16 12.466 15.032 12.786 14.776C13.1167 14.5093 13.282 14.1573 13.282 13.72Z",
    fill: "#1A6996"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdcopyIcon);
export default __webpack_public_path__ + "static/media/adcopy_icon.973ee4419861cb1c6cbb17fbfeeeb62d.svg";
export { ForwardRef as ReactComponent };